// import openDatabase from "../IndexedDB/openDatabase";

// const clearERPStores = async (
//   dbName = "ERP_DB",
//   storeNames = ["Client_Details", "Field_Access", "Enums"],
//   dbVersion = 1
// ) => {
//   try {
//     const db = await openDatabase(dbName, dbVersion);

//     // Ensure all specified object stores exist in the database
//     const missingStores = storeNames.filter((storeName) => !db.objectStoreNames.contains(storeName));
//     if (missingStores.length > 0) {
//       throw new Error(`Object store(s) not found: ${missingStores.join(", ")}`);
//     }

//     // Start a single readwrite transaction for all specified stores
//     const transaction = db.transaction(storeNames, "readwrite");

//     // Clear each specified object store
//     storeNames.forEach((storeName) => {
//       transaction.objectStore(storeName).clear();
//     });

//     // Wait for the transaction to complete
//     await new Promise((resolve, reject) => {
//       transaction.oncomplete = () => resolve();
//       transaction.onerror = () => reject(transaction.error);
//     });

//     console.log(`Successfully cleared stores: ${storeNames.join(", ")}`);
//   } catch (error) {
//     console.error("Error clearing object stores:", error);
//   }
// };

// export default clearERPStores;

// JUST COMMENTED TO SEE IF EVERYTHING GETS FIXED IF NOT UNCOMMENT FROM HERE TILL LAST
// const clearERPDatabase = async (dbName = "ERP_DB") => {
//   return new Promise((resolve, reject) => {
//     const deleteRequest = indexedDB.deleteDatabase(dbName);

//     deleteRequest.onsuccess = () => {
//       // console.log(`Database ${dbName} deleted successfully.`);
//       resolve();
//     };

//     deleteRequest.onerror = (event) => {
//       console.error(`Failed to delete database ${dbName}:`, event.target.error);
//       reject(event.target.error);
//     };

//     deleteRequest.onblocked = () => {
//       console.warn(`Delete operation blocked. Ensure all connections to the database are closed.`);
//     };
//   });
// };

// export default clearERPDatabase;
const storeNames = ["Client_Details", "Field_Access", "Enums"];

const clearERPDatabase = async (dbName = "ERP_DB", version = 1, storeNames) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, version);

    // Create missing stores here
    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      // Ensure stores exist
      for (const storeName of Object.values(storeNames)) {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName);
        }
      }
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction(db.objectStoreNames, "readwrite");

      transaction.oncomplete = () => {
        console.log("All stores cleared successfully.");
        db.close();
        resolve();
      };

      transaction.onerror = (event) => {
        console.error("Error clearing stores:", event.target.error);
        reject(event.target.error);
      };

      for (const storeName of db.objectStoreNames) {
        const store = transaction.objectStore(storeName);
        store.clear();
      }
    };

    request.onerror = (event) => {
      console.error(`Failed to open database ${dbName}:`, event.target.error);
      reject(event.target.error);
    };
  });
};

export default clearERPDatabase;
